'use client';

import { Box, Dialog } from '@mui/material';
import { useEffect, useState } from 'react';

export interface ImageProps {
  src: string;
  alt: string;
}

export function Image(props: ImageProps) {
  const [fullScreen, setFullScreen] = useState(false);

  function handleEscape(event: { key?: string }) {
    if (event.key === 'Escape') {
      setFullScreen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleEscape, false);

    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, []);

  function handleClick() {
    setFullScreen((previousFullScreen) => !previousFullScreen);
  }

  return (
    <Box sx={{ cursor: 'zoom-in' }} onClick={handleClick}>
      <img
        src={props.src}
        alt={props.alt}
        style={{
          maxWidth: '100%',
          margin: '0, auto',
          height: 'auto',
          borderRadius: '0.5rem',
          display: 'block',
        }}
      />
      <Dialog fullScreen open={fullScreen} onClose={() => setFullScreen(false)}>
        <Box
          position="relative"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          display="flex"
          sx={{
            cursor: 'zoom-out',
            backgroundColor: (theme) => theme.vars.palette.background.default,
          }}
        >
          <Box width="90%" height="90%" display="flex" alignItems="center" justifyContent="center">
            <img
              src={props.src}
              alt={props.alt}
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
                margin: 'auto',
              }}
            />
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
